import { Component, OnInit } from '@angular/core';
import { BookNoSearch } from '../../models/bookno-receipt-model';
import { AccountsHeader, Finyearmst, TallyReceiptModel, Txncategory } from '../../models/tallyentry-api-model';
import { TallyReceiptService } from '../../services/tallyentry-service';
import { UtilityService } from '../../services/utility-service';
import { DayBookListService } from '../../services/daybook-list-service';
import { MappingTransactionsService } from '../../services/mapping-transactions-service';
import { AccountsHeaderMapping, AccountsMapping, LedgerHead, TransactionMappingModel } from '../../models/mapping-transaction-model';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-mapping-transactions',
  templateUrl: './mapping-transactions.component.html',
  styleUrls: ['./mapping-transactions.component.css']
})
export class MappingTransactionsComponent implements OnInit {
  public l_formData: TransactionMappingModel = new TransactionMappingModel();
  public l_financialYearList = [];
  public l_categoryList: Txncategory[] = [];
  public l_creditToList: LedgerHead[] = [];
  public l_debitToList: LedgerHead[] = [];
  public l_accountsHeaderMappingList: AccountsHeaderMapping[] = [];
  public l_isMapped: boolean = false;
  public l_mappedUnmappedLabel: string = 'Unmapped Transactions';
  public l_accordionData = [];
  public l_btnLabel: string = 'Save Mapping';
  public isHovered: boolean = false;

  constructor(
    private l_UtilityService: UtilityService,
    private l_TallyReceiptService: TallyReceiptService,
    private l_DayBookListService: DayBookListService,
    private l_MappingTransactionsService: MappingTransactionsService,
    private l_datePipe: DatePipe
  ) {}

  ngOnInit(): void {
    this.lFN_GetCategorySelect();
    this.lFN_GetFinancialYear();
    this.lFN_GetLedgerHeadAccounts();
  }

  lFN_GetFinancialYearText(finyearmstId: number) {
    if (finyearmstId) {
      const year = this.l_financialYearList.find(year => year.finyearmstId === finyearmstId);
      return year ? year.finyear : '';
    }

  }

  lFN_GetCategorySelect() {
    let l_response = this.l_TallyReceiptService.lFN_GetCategory();
    l_response.subscribe({
      next: async (data) => {
        if (data.status == 200) {
          let l_categoryResponseList: Txncategory[] = [];
          console.log('success_response: ', JSON.parse(data.body));
          for await (const l_category of JSON.parse(data.body)) {
            l_categoryResponseList.push(new Txncategory(l_category));
          }
          this.l_categoryList = l_categoryResponseList;
          this.l_UtilityService.lFN_HideLoader();
        }
      },
      error: (l_error) => {
        console.error('error_response: ', l_error);
        this.l_UtilityService.lFN_ErrorToaster('Unable to fetch category list.', 'Failure');
        this.l_UtilityService.lFN_HideLoader();
      },
      complete: () => {
        console.log('Request completed');
        this.l_UtilityService.lFN_HideLoader();
      }
    });
  }

  lFN_GetFinancialYear() {
    let l_finyearResponse = this.l_TallyReceiptService.lFN_GetFinyearmst();
    l_finyearResponse.subscribe({
        next: async (data) => {
          if (data.status == 200) {
            let l_financialYearList: Finyearmst[] = [];
            for await (const l_finyear of JSON.parse(data.body)) {
              l_financialYearList.push(new Finyearmst(l_finyear))
            }
            this.l_financialYearList = l_financialYearList;
            console.log(this.l_financialYearList);
            this.l_UtilityService.lFN_HideLoader();
          }
        },
        error: (l_error) => {
          this.l_UtilityService.lFN_ErrorToaster('Unable to fetch Financial Year', 'Failure');
          this.l_UtilityService.lFN_HideLoader();
        },
        complete: () => {
          this.l_UtilityService.lFN_HideLoader();
        }
    });
  }

  lFN_GetLedgerHeadAccounts() {
    let l_ledgerHeadResponse = this.l_MappingTransactionsService.lFN_GetLedgerHeads();
    l_ledgerHeadResponse.subscribe({
      next: async (data) => {
        if (data.status == 200) {
          let l_creditToLedgerHeadList: LedgerHead[] = [];
          let l_debitToLedgerHeadList: LedgerHead[] = [];
          for await (const l_ledgerhead of JSON.parse(data.body)) {
            let l_ledger = new LedgerHead(l_ledgerhead);
            if(l_ledger.entryType === 'D') {
              l_debitToLedgerHeadList.push(l_ledger);
            } else {
              l_creditToLedgerHeadList.push(l_ledger);
            }
          }
          console.log('l_creditToLedgerHeadList == ', l_creditToLedgerHeadList);
          console.log('l_debitToLedgerHeadList == ', l_debitToLedgerHeadList);
          this.l_creditToList = l_creditToLedgerHeadList;
          this.l_debitToList = l_debitToLedgerHeadList;
          this.l_UtilityService.lFN_HideLoader();
        }
      },
      error: (l_error) => {
        this.l_UtilityService.lFN_ErrorToaster('Unable to fetch ledger heads', 'Failure');
        this.l_UtilityService.lFN_HideLoader();
      },
      complete: () => {
        this.l_UtilityService.lFN_HideLoader();
      }
    });
  }

  async lFN_ViewReceipt(element: any) {  
    let l_accountsHeader = this.l_DayBookListService.lFN_GetAccountHeaderById(element.accountsheaderId);
    l_accountsHeader.subscribe({
      next: async (data) => {
        if (data.status == 200) {
          console.log('success_response: ', data);
          this.l_UtilityService.lFN_ShowPopup("Receipt Details", JSON.parse(data.body));
        }
      },
      error: (l_error) => {
        console.error('error_response: ', l_error);
        this.l_UtilityService.lFN_ErrorToaster('Unable to fetch receipts by id.', 'Failure');
        this.l_UtilityService.lFN_HideLoader();
      },
      complete: () => {
        console.log('Request completed');
        this.l_UtilityService.lFN_HideLoader();
      }
    });
  }

  async lFN_SearchTransactionsMappings() {
    this.l_UtilityService.lFN_ShowLoader();
    console.log(this.l_formData);
    if (!this.l_formData.finyearmstId || !this.l_formData.txncategoryId) {
      this.l_UtilityService.lFN_WarningToaster('Please fill all the required fields', 'Warning');
      this.l_UtilityService.lFN_HideLoader();
      return;
    }

    let l_fromDateStr = this.l_datePipe.transform(this.l_formData.fromDate, 'yyyy-MM-dd');
    let l_toDateStr = this.l_datePipe.transform(this.l_formData.toDate, 'yyyy-MM-dd');

    let l_payload = {
      finyearmstId: this.l_formData.finyearmstId,
      txncategoryId: this.l_formData.txncategoryId,
      fromDate: ((l_fromDateStr) ? l_fromDateStr: null),
      toDate: ((l_toDateStr) ? l_toDateStr: null)
    }

    let l_transactionsMappings = this.l_MappingTransactionsService.lFN_GetMappingTransactions(l_payload, ((this.l_isMapped === true) ? 'mapped': 'unmapped'));
    l_transactionsMappings.subscribe({
      next: async (data) => {
        if (data.status == 200) {
          console.log('success_response: ', data);
          if(this.l_isMapped === false) {
            let l_accountsHeaderList: AccountsHeaderMapping[] = [];
            for await (const l_data of JSON.parse(data.body)) {
              let l_accountsHeaderObject = new AccountsHeaderMapping(l_data);
              l_accountsHeaderList.push(l_accountsHeaderObject);
            }
            this.l_accountsHeaderMappingList = l_accountsHeaderList;
            this.l_accordionData = this.l_accountsHeaderMappingList.map(() => ({ creditToId: null, debitToId: null, isEdit: false }));
            this.l_btnLabel = 'Save Mapping';
          }
          else {
            let l_accountsHeaderList: AccountsHeaderMapping[] = [];
            for await (const l_data of JSON.parse(data.body)) {
              let l_accountsHeaderObject = new AccountsHeaderMapping(l_data);
              l_accountsHeaderList.push(l_accountsHeaderObject);
            }
            this.l_accountsHeaderMappingList = l_accountsHeaderList;
            this.l_accordionData = this.l_accountsHeaderMappingList.map((l_accountsHeader) => 
              ({ creditToId: l_accountsHeader.accountsMapping.creditLedgerId, debitToId: l_accountsHeader.accountsMapping.debitLedgerId, isEdit: true }));
            this.l_btnLabel = 'Edit Mapping';
          }
        }
      },
      error: (l_error) => {
        console.error('error_response: ', l_error);
        this.l_UtilityService.lFN_ErrorToaster('Unable to fetch transactions mappings.', 'Failure');
        this.l_UtilityService.lFN_HideLoader();
      },
      complete: () => {
        console.log('Request completed');
        this.l_UtilityService.lFN_HideLoader();
      }
    });
  }

  lFN_GetFromattedDate(l_date: any) {
    let date = new Date(l_date);
    let day = String(date.getDate()).padStart(2, '0');
    let month = String(date.getMonth() + 1).padStart(2, '0');
    let year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }

  lFN_OnToggleChange(event: any) {
    this.l_isMapped = event.checked;
    console.log('this.l_isUnmapped == ', this.l_isMapped);
    if(this.l_isMapped === true) {
      this.l_mappedUnmappedLabel = 'Mapped Transactions';
    } else {
      this.l_mappedUnmappedLabel = 'Unmapped Transactions';
    }
  }

  async lFN_SaveMappingTransaction(l_mapping: AccountsHeaderMapping, l_index: number) {
    console.log('this.l_index == ', l_index);
    console.log('this.l_accordionData == ', this.l_accordionData);

    let l_creditDebitObject = this.l_accordionData[l_index];
    console.log('l_creditDebitObject == ', l_creditDebitObject);

    if(l_creditDebitObject.isEdit === true) {
      //_fetch_accmappingId
      let l_accmappingId = l_mapping.accountsMapping.accountsmappingId;
      let l_creditToLedgerName = this.l_creditToList.find(creditTo => (creditTo.ledgerHeadId === l_creditDebitObject.creditToId)).name;
      let l_debitToLedgerName = this.l_debitToList.find(debitTo => (debitTo.ledgerHeadId === l_creditDebitObject.debitToId)).name;
      console.log('l_creditToLedgerName === ', l_creditToLedgerName);
      console.log('l_debitToLedgerName === ', l_debitToLedgerName);
  
      let l_accountsHeader = new AccountsHeader({
        accountsheaderId: l_mapping.accountsheaderId
      });
  
      let l_transactionMapping = new AccountsMapping({
        debitLedgerId: l_creditDebitObject.debitToId,
        debitTo: l_debitToLedgerName,
        creditLedgerId: l_creditDebitObject.creditToId,
        creditTo: l_creditToLedgerName,
        mappingsts: true,
        accountsHeader: l_accountsHeader,
        accountsmappingId: l_accmappingId
      });

      await this.lFN_SaveEditMappingTransactions(l_transactionMapping);
    }
    else {
      let l_creditToLedgerName = this.l_creditToList.find(creditTo => (creditTo.ledgerHeadId === l_creditDebitObject.creditToId)).name;
      let l_debitToLedgerName = this.l_debitToList.find(debitTo => (debitTo.ledgerHeadId === l_creditDebitObject.debitToId)).name;
      console.log('l_creditToLedgerName === ', l_creditToLedgerName);
      console.log('l_debitToLedgerName === ', l_debitToLedgerName);
  
      let l_accountsHeader = new AccountsHeader({
        accountsheaderId: l_mapping.accountsheaderId
      });
  
      let l_transactionMapping = new AccountsMapping({
        debitLedgerId: l_creditDebitObject.debitToId,
        debitTo: l_debitToLedgerName,
        creditLedgerId: l_creditDebitObject.creditToId,
        creditTo: l_creditToLedgerName,
        mappingsts: true,
        accountsHeader: l_accountsHeader
      });
      await this.lFN_SaveEditMappingTransactions(l_transactionMapping);
    }
    
  }

  async lFN_SaveEditMappingTransactions(l_transactionMapping: AccountsMapping) {
    let l_savemappingResponse = this.l_MappingTransactionsService.lFN_SaveMappingTransactions(l_transactionMapping);
    l_savemappingResponse.subscribe({
      next: async (data) => {
        if (data.status == 200) {
          console.log('save success_response: ', data);
          this.l_UtilityService.lFN_SuccessToaster(((l_transactionMapping.accountsmappingId) ? 'Transaction Mapping edited successfully.': 'Transaction Mapping created successfully.'), 
          ((l_transactionMapping.accountsmappingId) ? 'Edited successfully': 'Saved successfully'));
          setTimeout(async () => {
            await this.lFN_SearchTransactionsMappings();
          }, 2000);
        }
      },
      error: (l_error) => {
        console.error('error_response: ', l_error);
        this.l_UtilityService.lFN_ErrorToaster('Error while saving transactions mappings.', 'Something went wrong');
        this.l_UtilityService.lFN_HideLoader();
      },
      complete: () => {
        console.log('Request completed');
        this.l_UtilityService.lFN_HideLoader();
      }
    });
  }

  onHover(hoverState: boolean) {
    this.isHovered = hoverState;
  }

}
